import React, { useMemo } from "react"
import ClockFading from "../../../../assets/ClockFading"
import MarkdownWrapper from "../../../MarkdownWrapper"

/**
 * @typedef {Object} ProtocolMessage
 * @property {number} [ephemeralExpiration]
 */

/**
 * @typedef {Object} MessageProtocolData
 * @property {ProtocolMessage} [protocolMessage]
 */

/**
 * @typedef {Object} MessageData
 * @property {MessageProtocolData} [message]
 */

/**
 * @typedef {Object} EphemeralMessageProps
 * @property {import("../MessageItem").Message} message
 * @property {import("@material-ui/styles").ClassNameMap} classes
 */

/**
 * Componente que exibe informações sobre mensagens temporárias.
 *
 * @param {EphemeralMessageProps} props
 */
const EphemeralMessage = React.memo(
  /**
   * @param {EphemeralMessageProps} props
   */
  ({ message, classes }) => {
    /** @type {number} */
    const ephemeralExpiration = useMemo(() => {
      try {
        if (!message.dataJson) return 86400

        /** @type {MessageData} */
        const data = JSON.parse(message.dataJson)

        return data.message?.protocolMessage?.ephemeralExpiration ?? 86400
      } catch (error) {
        console.error("Erro ao parsear dataJson:", error)
        return 86400
      }
    }, [message.dataJson])

    /** @type {string} */
    const ephemeralTime = useMemo(() => {
      switch (ephemeralExpiration) {
        case 86400:
          return "24 horas"
        case 604800:
          return "7 dias"
        case 7776000:
          return "90 dias"
        default:
          return ""
      }
    }, [ephemeralExpiration])

    return (
      <div className={classes.ephemeralMessageBg}>
        <div className={classes.ephemeralMessage}>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <ClockFading />
            <MarkdownWrapper>
              {ephemeralExpiration === 0 ? "Mensagens temporárias desativadas" : "Mensagens temporárias ativadas"}
            </MarkdownWrapper>
          </div>

          {ephemeralExpiration > 0 && (
            <h6 style={{ margin: 0, fontSize: 10 }}>
              As mensagens serão apagadas do WhatsApp após {ephemeralTime}, mas continuarão visíveis no Talk.
            </h6>
          )}
        </div>
      </div>
    )
  },
)

EphemeralMessage.displayName = "EphemeralMessage"

export default EphemeralMessage
